import type { FC } from "react";
import { Skeleton } from "@mui/material";
import Grid from "@mui/material/Grid";

const LoadingSkeleton: FC = () => {
  return (
    <Grid
      container
      p={2}
      flexDirection={"column"}
      gap={1}
      role="status"
      aria-label="Loading recent orders"
      data-testid="recent-orders-loading"
    >
      <Skeleton data-testid="recent-orders-skeleton-row" />
      <Skeleton data-testid="recent-orders-skeleton-row" />
    </Grid>
  );
};

export default LoadingSkeleton;
